export interface PageLocation {
    readonly protocol: string;
    readonly host: string;
}

export function getWebSocketUrl(location: PageLocation): string {
    const protocol = location.protocol === "https:" ? "wss:" : "ws:";
    return `${protocol}//${location.host}/ws`;
}
